<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-back="false" :has-nav="false">
    <div class="o-y-auto" style="background-color: #F4F8FF;height: calc(100% - 40px)">
      <div class="w-full" style="min-height: calc(100% - 64px)">
        <div class="m-auto bg-white" style="width: 820px;">
          <div class="bold fs-16  p-v-10 p-h-20">上传视频</div>
          <div class="p-h-20">
            <Row :gutter="16">
              <Col span="12">
                <div class="o-hidden w-full" style="height: 255px;position: relative;top: 0;left: 0;">
                  <video-upload-s :canclick="canclick" :funcallback="onVideoUpload"
                                  @uploadSuccess="uploadFileSuccess"
                                  @uploadstart="onItemVideoUploadStart" videoInfix="common/desc/">
                    <template slot="tip">
                      <div class="flex-column a-center j-center w-full" style="height: 255px;background-color: #F6F9FF;"
                           v-if="!mp4Url">
                        <img alt="" src="../../../assets/common/ic_upload_video@2x.png" style="width: 64px;height: 64px"
                             v-if="progress === 0">
                        <div class="m-t-5  color-66" v-if="progress === 0">上传视频</div>
                        <Progress :percent="progress" class="p-h-10" v-if="progress>0"/>
                      </div>

                      <div class="flex a-center j-center w-full" style="height: 255px;" v-if="mp4Url">
                        <video :src="mp4Url" class="w-full h-full" id="video-sid" ref="video"
                               style="object-fit: fill"></video>
                        <img alt="" class="absolute right-150 top-68 w-50 h-50"
                             src="../../../assets/common/ic_player(2).png" style="z-index: 20;">
                      </div>
                    </template>
                  </video-upload-s>
                  <div @click="onVideoDelClick"
                       style="z-index: 10;position: absolute;right: 0;top: 0"
                       v-if="mp4Url">
                    <img alt="" src="../../../assets/common/ic_delete_circle_red.png">
                  </div>
                  <div class="absolute left-0 top-0 w-full" style="height: 255px;" v-if="mp4Url">
                    <img :src="imgUrl" alt="" class="w-full" style="min-height: 100%">
                  </div>
                </div>

                <div class="color-66 fs-12 p-t-10" style="">
                  视频格式为mp4,视频大小不超过200Mb
                </div>
              </Col>
              <Col span="12">
                <div>
                  <div @click="onPicChoose" style="position: relative;left: 0;top: 0">
                    <div class="flex-column a-center j-center w-full"
                         style="height: 255px;background-color: #F6F9FF;cursor: pointer">
                      <img alt="" src="../../../assets/common/ic_upload_picture@2x.png"
                           style="width: 64px;height: 64px">
                      <span class="m-t-5  color-66">上传视频封面</span>
                    </div>
                    <div class="o-hidden"
                         style="position: absolute;height: 255px;left: 0;top: 0;background-color: #F6F9FF;"
                         v-if="imgUrl">
                      <img :src="imgUrl" class="w-full" style="min-height: 100%"/>
                    </div>
                  </div>
                </div>
                <div class="color-66 fs-12 p-t-10" style="">
                  图片格式为jpg或png,图片比例为4:3,图片大小不超过5Mb
                </div>
              </Col>
            </Row>

          </div>

          <div class="m-t-10 p-h-20">
            <Row :gutter="15">
              <Col span="12">
                <class-vertical-choose-widget :objData="objData" :srcType="10" direction="horizontal"
                                              leftLabelText="视频分类"
                                              rightLabelText="视频分组">

                </class-vertical-choose-widget>
              </Col>
              <Col span="12">
                <div class="w-full" style="height: 80px;">
                  <span class="bold fs-14 color-33">视频标题:</span>
                  <Input class="m-t-10 w-full" maxlength="60" placeholder="视频标题" type="text" v-model="VideoTitle"/>
                </div>
              </Col>
            </Row>
          </div>
          <!--<div style="width: 300px;height: 80px;margin-left: 20px">-->
          <!--<span class="bold fs-14 color-33">详情标题:</span>-->
          <!--<Input class="m-t-10" maxlength="10" placeholder="视频详情标题" type="text"/>-->
          <!--</div>-->

          <!--<div-->
          <!--style="min-height: 400px; margin-left: 20px;margin-bottom: 20px;padding-bottom:20px;display: flex;flex-wrap: wrap;flex-direction: column">-->

          <!--<ul>-->
          <!--<li class=" clear" style="float:left;margin-right: 15px;margin-top: 20px;">-->
          <!--<up-load-image @uploadSuccess="uploadDescImageSuccess" accept="image/*"-->
          <!--multiple-->
          <!--picurl="goods/goods/"-->
          <!--style="width:182px;height: 145px;">-->
          <!--<template v-slot:tip>-->
          <!--<div style="width: 182px;">-->
          <!--<div class="flex-column a-center j-center  m-b-10"-->
          <!--style="width: 182px;height: 145px;background-color: #F6F9FF;cursor: pointer">-->
          <!--<img alt="" src="../../../assets/common/ic_upload_picture@2x.png"-->
          <!--style="width: 64px;height: 64px">-->
          <!--<span class="m-t-5  color-66">上传图片</span>-->
          <!--</div>-->
          <!--</div>-->
          <!--</template>-->
          <!--</up-load-image>-->
          <!--</li>-->
          <!--<draggable :move="onMove"-->
          <!--:options="dragOptions1"-->
          <!--@end="isDragging=false"-->
          <!--@start="isDragging=true"-->
          <!--element="ul"-->
          <!--v-model="imageList">-->
          <!--<li :key="index" class="clear"-->
          <!--style="float: left;margin-right: 15px;margin-top: 20px"-->
          <!--v-for="(item,index) in imageList">-->
          <!--<div class="border  relative hoverstyle" style="width:182px;height: 145px;">-->
          <!--<div class="w-full o-hidden" style="height: 149px;">-->
          <!--<img :src="item.url" alt="" class="w-full v-a-center"-->
          <!--style="object-fit: fill;width: 100%;height: 149px">-->
          <!--</div>-->
          <!--<div @click="onItemDel(imageList,index)" class="showdel"-->
          <!--style="position: absolute;top: -10px;right: -10px">-->
          <!--<i class="icon-delete_small fs-20"-->
          <!--style="color: #F44336;cursor: pointer"/>-->
          <!--</div>-->
          <!--</div>-->
          <!--</li>-->
          <!--</draggable>-->
          <!--</ul>-->
          <!--</div>-->
        </div>
      </div>
      <div class="m-auto bg-white flex a-center j-end"
           style="width: 820px;position: sticky;bottom: 0;left: 0;height: 64px;box-shadow: 0px 0px 8px 0px rgba(1, 0, 52, 0.12);">
        <Button @click="onCancelClick" style="width: 76px">取消</Button>
        <Button @click="onVideoSaveClick" class="m-l-20" style="  margin-right: 38px;width: 76px" type="primary">保存
        </Button>
      </div>
    </div>

    <pic-choice-widget
      :on-ok="picChoiceOk"
      ref="picChoiceWidget"
    />

  </base-page-component>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import draggable from 'vuedraggable'
import UpLoadVideo from '@/components/common/UpLoadVideo'
import VideoEditTest from '@/components/common/VideoEditTest'
import ClassVerticalChooseWidget from '../../../components/common/ClassVerticalChooseWidget'
import PicChoiceWidget from '../../../components/common/chiose/PicChoiceWidget'
import VideoUploadS from '../../../components/common/VideoUpload'
import {mapActions, mapMutations} from 'vuex'

export default {
  name: 'EditVideo',
  components: {
    PicChoiceWidget,
    ClassVerticalChooseWidget,
    VideoEditTest,
    BasePageComponent,
    UpLoadImage,
    draggable,
    UpLoadVideo,
    VideoUploadS
  },
  data () {
    return {
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      videoUrl: '',
      mp4Url: '',
      imgUrl: '',
      progress: 0,
      VideoTitle: '',
      canclick: true,

      // title: '',
      // isDragging: false,
      // imageList: [],            // 图片列表

      process: '',  //上传进度条

    }
  },
  computed: {
    dragOptions1 () {    //拖动参数
      return {
        animation: 0,
        group: {
          name: 'description',
          // pull: 'clone',
          // put: false
        },
        scroll: true,
        ghostClass: 'ghost',
        scrollSensitivity: 30,
        forceFallback: false,
        disabled: false
      }
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      this.id = this.$route.query.videoId
      this.getVideoDetails()
    },

    getVideoDetails () {
      let id = this.id
      let params = {}
      this.getVideoDetail({
        id,
        params
      }).then(res => {
        if (res.code === 0) {
          this.imgUrl = res.data.coverImgUrl
          this.videoUrl = res.data.url
          this.mp4Url = res.data.sourceUrl
          this.VideoTitle = res.data.title
          this.objData = {
            classId: res.data.categoryId,
            groupId: res.data.groupId,
            init: true
          }
        }
      })
    },
    // onMove ({relatedContext, draggedContext}) {
    //   const relatedElement = relatedContext.element
    //   const draggedElement = draggedContext.element
    //   return (
    //     (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    //   )
    // },
    /**
     * 图片删除处理
     * @param arrayList
     * @param index
     */
    // onItemDel (arrayList, index) {
    //   arrayList.splice(index, 1)
    // },

    /**
     *上传图片
     * @param data
     */
    // uploadDescImageSuccess (data) {
    //   if (data && data.length) {
    //     let list = data.map(res => {
    //       return {
    //         url: res.url
    //       }
    //     })
    //     this.imageList = this.imageList.concat(list)
    //   }
    // },
    onItemVideoUploadStart () {
      this.canclick = false
      this.videoUrl = ''
      this.progress = 0
    },
    onVideoUpload (data) {
      this.progress = Number.parseInt(data * 100)
    },
    uploadFileSuccess (data) {
      if (data && data.length) {
        this.videoUrl = data[0].videoUrl
        this.mp4Url = data[0].videoUrl
        this.VideoTitle = data[0].localfile.name
      }
      this.progress = 0
      this.canclick = true

    },
    onPicChoose () {
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        this.imgUrl = data[0].url
      }
    },
    onCancelClick () {
      this.$router.go(-1)
      this.closeTag({
        name: 'EditVideo'
      })
    },
    onVideoSaveClick () {
      if (!this.videoUrl) {
        return this.$Message.warning('请先上传视频')
      }
      if (!this.VideoTitle) {
        return this.$Message.warning('请输入视频名称')
      }

      let width = 0
      let height = 0
      if (this.mp4Url) {
        let video = document.getElementById('video-sid')
        width = video.videoWidth
        height = video.videoHeight
      }

      let params = {
        groupId: this.objData.groupId,
        categoryId: this.objData.classId,
        coverImgUrl: this.imgUrl,
        length: this.$refs.video.duration,
        url: this.videoUrl,
        title: this.VideoTitle,
        desc: '',
        jumpLink: '',
        width: width || 0,
        height: height || 0,
      }
      let id = this.id
      this.editVideo({
          id,
          params
        }
      ).then(res => {
        if (res.code === 0) {
          this.$router.go(-1)
          this.closeTag({
            name: 'EditVideo'
          })
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },

    onVideoDelClick () {
      this.videoUrl = ''
      this.mp4Url = ''
    },

    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'editVideo',
      'getVideoDetail'
    ])
  },
}
</script>

<style lang="scss" scoped>
  .hoverstyle {
    &:hover {
      .showdel {
        display: block;
      }
    }

    .showdel {
      display: none;
    }
  }

</style>
